module.exports = __webpack_public_path__ + "static/media/supervised_user_circle_24px.28cb3430.svg";